import { useCallback, useMemo, useState } from "react";

export function useResolvedWriteApprovals() {
  const [resolvedToolCallIds, setResolvedToolCallIds] = useState<Set<string>>(() => new Set());

  const markResolved = useCallback((toolCallId: string) => {
    setResolvedToolCallIds((prev) => {
      if (prev.has(toolCallId)) return prev;
      const next = new Set(prev);
      next.add(toolCallId);
      return next;
    });
  }, []);

  const clearResolved = useCallback(() => {
    setResolvedToolCallIds(new Set());
  }, []);

  return useMemo(
    () => ({ resolvedToolCallIds, markResolved, clearResolved }),
    [resolvedToolCallIds, markResolved, clearResolved]
  );
}
